import { render } from "./associationManagement.vue?vue&type=template&id=fa65f402&scoped=true"
import script from "./associationManagement.vue?vue&type=script&lang=js"
export * from "./associationManagement.vue?vue&type=script&lang=js"

import "./associationManagement.vue?vue&type=style&index=0&id=fa65f402&lang=scss&scoped=true"
import "./associationManagement.vue?vue&type=style&index=1&id=fa65f402&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa65f402"]])

export default __exports__